import { Matcher } from 'react-day-picker';

import { toTruthyList } from 'utils/array';
import { omitUndefined } from 'utils/object';

interface FromToProps {
  disablePast?: boolean;
  disableFuture?: boolean;
  fromDate?: Date;
  toDate?: Date;
  disabled?: Matcher | Matcher[];
  // fromMonth?: Date;
  // toMonth?: Date;
  // fromYear?: number;
  // toYear?: number;
}

function calculateMaxDate(toDate: Date | undefined, disableFuture?: boolean): Date | undefined {
  const today = new Date();

  if (!toDate && !disableFuture) return;

  if (disableFuture && !toDate) return today;

  const earliest = Number(today) < Number(toDate) ? today : toDate;

  return earliest;
}

function calculateMinDate(fromDate: Date | undefined, disablePast?: boolean): Date | undefined {
  const today = new Date();

  if (!fromDate && !disablePast) return;

  if (disablePast && !fromDate) return today;

  const latest = Number(today) < Number(fromDate) ? fromDate : today;

  return latest;
}

export function calculateFromToRange({
  disableFuture,
  disablePast,
  fromDate,
  toDate,
  disabled,
}: FromToProps) {
  const maxDate = calculateMaxDate(toDate, disableFuture);

  const minDate = calculateMinDate(fromDate, disablePast);

  const finalDisabled = toTruthyList([
    disabled,
    maxDate || minDate
      ? omitUndefined({
          after: maxDate,
          before: minDate,
        })
      : null,
  ]) as Matcher[];

  return {
    startMonth: minDate,
    endMonth: maxDate,
    disabled: finalDisabled,
  };
}
